'use client'

import { EditableText } from '../functionality/EditableText'
import { BlockBadge } from './BlockBadge'

export function BlockHeader({
  eyebrow,
  title,
  titleOnSave,
  badge,
  badgeOnSave,
  badgeVariant,
  className = '',
}) {
  const hasEyebrow = Boolean(eyebrow)
  const hasTitle = title !== undefined && title !== null
  const hasBadge = Boolean(badge)

  if (!hasEyebrow && !hasTitle && !hasBadge) return null

  return (
    <header className={`nb-block-header ${className}`.trim()}>
      {hasEyebrow && (
        <div className="nb-block-header__eyebrow">{eyebrow}</div>
      )}
      {(hasTitle || hasBadge) && (
        <div className="nb-block-header__row">
          {hasTitle && (
            <div className="nb-block-header__title">
              {titleOnSave ? (
                <EditableText
                  value={title}
                  onSave={titleOnSave}
                  multiline={false}
                  inline
                />
              ) : (
                title
              )}
            </div>
          )}
          {hasBadge && (
            <BlockBadge
              text={badge}
              variant={badgeVariant}
              onSave={badgeOnSave}
            />
          )}
        </div>
      )}
    </header>
  )
}
